export default {
  add_products: '+ Producten toevoegen',
};
